import React from 'react'
import EzCancelPlus from 'SVGPath/EzcancelPlusIcon'
import { isEmpty } from 'AccountsUtils'
import { path } from 'AccountsUtils/common'

const EzcancelPlusBanner = ({ bannerData = {} }) => {
  const bannerInfoObj = {
    AVAILED: {
      bannerColor: '#EBF9F6',
      iconWidth: '22px'
    },
    AVAILED_CANCELLED: {
      bannerColor: '#FBECEC',
      iconWidth: '12px'
    }
  }
  let bannerObj = (bannerData && bannerInfoObj[bannerData.status]) || {}
  if (isEmpty(bannerObj)) {
    bannerObj = {
      bannerColor: '#FCF7F0',
      iconWidth: '22px'
    }
  }
  bannerObj.vasType = bannerData.vas_type
  const domain = path(['location', 'hostname'], window)
  return (
    <div className="flex flex-start px-3 py-3" style={{ backgroundColor: bannerObj.bannerColor }}>
      <div className="flex-no-shrink">
        <If condition={bannerObj.vasType === 'FLEXIFLY'}>
          <img
            width="18px"
            height="18px"
            alt="insurance"
            src="https://qaui.cltp.co/images/logos/amend_insurance.png"
          />
        </If>
        <If condition={bannerObj.vasType === 'EZCANCEL_PLUS'}>
          <EzCancelPlus width={bannerObj.iconWidth} height={bannerObj.iconWidth} />
        </If>
      </div>
      <div className="fs-3 ml-1 ff-inter">
        {bannerData.message && bannerData.message.toString()}
        {' '}
        <span
          onClick={() => {
            window.open(`https://${domain}/${bannerData.url}`)
          }}
          className="c-secondary-500 ff-inter"
        >
          {bannerData.url_text}
        </span>
      </div>
    </div>
  )
}

export default EzcancelPlusBanner
